import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import Card from '../../common/components/Card';

class RecommendedNearbyCenters extends Component {
    render() {
        const { t, centers, onSelectCenter } = this.props;
        return <div>
            <h4>{t('FO_Booking_NearbyCenters')}</h4>
            {centers.map(center => (
                <Card title={<span>{center.name}</span>} style={{ cursor: 'pointer' }} onClick={() => onSelectCenter(center.id)}>
                    <div>{center.address}</div>
                    <div>{center.phoneNumber ? center.phoneNumber : (center.mobilePhone ? center.mobilePhone : '')}</div>
                </Card>
            ))}
        </div>;
    }
}

export default withNamespaces()(RecommendedNearbyCenters);
